import { DARK_MODE } from "./types";

//  Toggle darkmode
export const toggleDarkMode = () => async (dispatch) => {
	dispatch({
		type: DARK_MODE,
	});
};
